// extracted by mini-css-extract-plugin
export default {"label":"ImgInfo_label__Uwv3M","score":"ImgInfo_score__P1iy-","red":"ImgInfo_red__x54kB","gold":"ImgInfo_gold__BeGra","green":"ImgInfo_green__9MwIO","grey":"ImgInfo_grey__pRdzw"};